import { computed, Directive, input } from '@angular/core';

type TableVariant = 'styled' | 'unstyled';
type TableModifier = 'padded' | 'bottom-border';

@Directive({
    selector: '[mat-table][qpx]',
    host: {
        '[class]': 'className()',
    },
})
export class QpxTable {
    // --- Inputs ---
    public readonly size = input<'sm' | 'md'>('md');

    public readonly variant = input<TableVariant>('styled');

    public readonly modifier = input<
        TableModifier[],
        TableModifier | TableModifier[]
    >([], {
        transform: (value: TableModifier | TableModifier[]) =>
            Array.isArray(value) ? value : [value],
    });

    // --- State ---
    protected readonly className = computed(() => {
        const variant = this.variant();
        const modifiers = this.modifier();

        if (variant === 'unstyled') return 'unstyled';

        return [
            'qpx-table',
            this.size(),
            ...(variant === 'styled' ? [] : [variant]),
            ...modifiers,
        ].join(' ');
    });
}
